export default {"src":"/_next/static/media/AmericanExpress.a882ea6c.svg","height":28,"width":29};